import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AccessibilityToolbar from "@/components/AccessibilityToolbar";

export default function PublicLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col bg-base text-ink">
      <a href="#main-content" className="skip-link" data-testid="skip-link">
        {t("a11y.skip_to_content")}
      </a>
      <Navbar />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <aside role="complementary" aria-label={t("a11y.title")}>
        <AccessibilityToolbar />
      </aside>
    </div>
  );
}
